import {
  IoAddOutline,
  IoDocumentOutline,
  IoEllipsisHorizontalOutline,
  IoMailOutline,
  IoSettingsOutline,
} from "react-icons/io5";
import { useState } from "react";
import TextboxSearch from "./../../../../components/common/TextboxSearch";
import Modal from "./../../../../components/common/Modal";
import Dropdown from "./../../../../components/common/Dropdown";
import TaxesTable from "./components/TaxesTable";
import TaxForm from "./components/TaxForm";
import Toaster from "../../../../components/common/Toaster";
import Loader from "./../../../../components/common/Loader";
import taxService from "../../../../services/taxService";

const Taxes = ({ id, account, onRefresh }) => {
  const [taxes, setTaxes] = useState([]);
  const [data, setData] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isSending, setIsSending] = useState(false);

  const [tableOptions, setTableOptions] = useState({
    search_query: "",
    current_page: 1,
    page_size: 10,
    sort_column: { path: "filing_date", order: "desc" },
  });

  const actions = (data) => {
    return [
      [
        {
          name: "View Document",
          icon: <IoDocumentOutline className="mr-3 text-green-500" />,
          is_disabled: !data.s3_reference_name,
          action: () =>
            window.open(
              data.s3_reference_name,
              "_blank",
              "noopener, noreferrer"
            ),
        },
      ],
      [
        {
          name: "Send File via Email",
          icon: <IoMailOutline className="mr-3 text-blue-500" />,
          is_disabled: !data.s3_reference_name,
          action: () => handleSendFile(data.id),
        },
      ],
      [
        {
          name: "Edit Tax",
          icon: <IoSettingsOutline className="mr-3 text-gray-400" />,
          action: () => handleEdit(data),
        },
      ],
    ];
  };

  const columns = [
    { path: "return_period", label: "Period" },
    { path: "tax_type_name", label: "Tax Type" },
    { path: "amount", label: "Amount" },
    { path: "filing_date", label: "Date of Filing" },
    {
      key: "actions",
      content: (data) => {
        return (
          <Dropdown
            items={actions(data)}
            icon={<IoEllipsisHorizontalOutline />}
          />
        );
      },
    },
  ];

  const handleOptionsChange = (options) => setTableOptions(options);

  const handleSearch = (query) => {
    const options = { ...tableOptions };

    if (options.search_query !== query) {
      options.search_query = query;
      options.current_page = 1;
      handleOptionsChange(options);
    }
  };

  const handleSendFile = async (id) => {
    try {
      setIsSending(true);

      await taxService.sendFileEmailAsync(id);

      setIsSending(false);
      Toaster.Success("File Sent Successfully!");
    } catch (ex) {
      setIsSending(false);
      Toaster.Error("Something went wrong.");
    }
  };

  const handleEdit = (item) => {
    const result = item ?? null;
    setData(result);
    setShowForm(!showForm);
  };

  const handleSuccess = () => {
    const options = { ...tableOptions };
    setTableOptions(options);
    setShowForm(false);
    setData(null);
    onRefresh();
  };

  return (
    <div className="card p-8">
      {isSending && <Loader />}
      <div className="block sm:flex justify-between items-center">
        <div>
          <p className="text-gray-400 text-sm">Tax Management</p>
          <span className="text-gray-400 text-xs">List of Taxes</span>
        </div>
        <div className="mt-5 sm:mt-0">
          <button
            className="button button-primary"
            onClick={() => setShowForm(true)}
          >
            <IoAddOutline className="mr-2" />
            File Tax
          </button>
        </div>
      </div>
      <div className="block sm:justify-between items-center mt-8">
        <TextboxSearch placeholder="Search..." onSearch={handleSearch} />
      </div>
      <div className="mt-8">
        <TaxesTable
          id={id}
          columns={columns}
          data={taxes}
          tableOptions={tableOptions}
          setData={setTaxes}
          onChange={handleOptionsChange}
        />
      </div>
      <Modal
        size="md"
        title="File Tax"
        isOpen={showForm}
        onClose={handleEdit}
        borderTop
      >
        <TaxForm
          id={id}
          data={data}
          account={account}
          isLoading={isLoading}
          setLoading={setIsLoading}
          onSuccess={handleSuccess}
        />
      </Modal>
    </div>
  );
};

export default Taxes;
